import Nav from './modules/mainNav';
import SiteSearch from './modules/siteSearch';
import ReturnPointsCarousel from './modules/returnPointsCarousel';
import NewsCardCarousel from './modules/newsCardCarousel';

import StickyHeader from './modules/stickyHeader';
import StickyInnerHeader from './modules/stickyInnerHeader';
import GenericTab from './modules/genericTab';
import AutoComplete from './modules/autoComplete';
import GeoLocation from './modules/geoLocation';
import LocationSearch from './modules/locationSearch';
import ChangePlaceholderText from './modules/changePlaceholderText';
import TruncateNewsCardText from './modules/truncateNewsCardText';
import RemoveCmsImageWidthHeight from './modules/removeCmsImageWidthHeight';

import NewsSearch from './modules/newsSearch';

import sameHeight from './modules/sameHeight';
import makeItemSameHeight from './modules/makeItemSameHeight';
import infoHelp from './modules/infoHelp';
import Kpi from './modules/kpi';
import DownloadToolkits from './modules/downloadToolkits'
/**
 * https://github.com/jonathantneal/keyboard-focus
 * To distinguish keyboard focus and mouse focus, quite useful for accessibility
 */
import keyboardFocus from 'keyboard-focus';
import { get } from 'https';

$(document).ready(function(){
  window.locationDataWT = [];
  window.globalMarker = [];
  Nav.init();
  SiteSearch.init();
  ReturnPointsCarousel.init();
  NewsCardCarousel.init();
  StickyHeader.init();
  StickyInnerHeader.init();
  GenericTab.init();
  AutoComplete.init();
  GeoLocation.init();
  sameHeight.init();
  makeItemSameHeight.init();
  infoHelp.init();
  ChangePlaceholderText.init();
  if($('.c-kpi-widget').length){
    Kpi.init();
  }
  DownloadToolkits.init();

  // in cms content page, if image exists, remove inline width and height attributes
  if($('.c-cms-content-wrapper').length){
    RemoveCmsImageWidthHeight.init();
  }
  // Load keyboard focus
  keyboardFocus(document);

  if($('.c-return-point-result').length){
      
      LocationSearch.init();
  }
  if($('.c-news-card__item').length){
      TruncateNewsCardText.init();
  }
  if($('.c-news-list').length){
      NewsSearch.init();
  }

  // Hide holiday message on clicking on "close" icon.
  $('.js-holiday-banner-hide').on("click", function () {
    $(this).closest('.c-return-point-detail__holiday-banner').fadeOut();
  });

  // for touch device
  var touchsupport = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)
  if (!touchsupport){ // browser doesn't support touch
      document.documentElement.className += " non-touch"
  }
  $('.js-accordion').accordion({ buttonsGeneratedContent: 'html' });
  
  // Eligibility Too carousel
  $('.container-slick-carousel__container').slick({
    autoplay: false,
    accessibility: true,
    prevArrow: $('.c-container-returned-carousel').find('.c-button--left-arrow'),
    nextArrow: $('.c-container-returned-carousel').find('.c-button--right-arrow'),
    mobileFirst: true,
    touchMove:true,
    dots: true,
    dotsClass: 'o-list-inline u-margin-bottom-small carousel-dots',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    appendDots: $('.c-container-returned-carousel__dots')
  })

  // Generic carousel - RVM, OTC, AD, DS
  $('.generic-slick-carousel__container').slick({
      autoplay: false,
      accessibility: true,
      prevArrow: $('.c-generic-carousel-widget').find('.c-button--left-arrow'),
      nextArrow: $('.c-generic-carousel-widget').find('.c-button--right-arrow'),
      mobileFirst: true,
      touchMove:true,
      dots: true,
      dotsClass: 'o-list-inline u-margin-bottom-small carousel-dots',
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
      appendDots: $('.c-generic-carousel__dots')
  })

  // Live KPI carousel
  $('.c-live-return-items').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: true,
    swipe: false,
    touchMove: false,
    accesibility: false,
    autoplay: true,
    speed: 300,
    cssEase: 'ease-in-out'
  });

  // RP detail page - state carousel
  $('.c-return-point-detail--status-items').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    fade: true,
    swipe: false,
    touchMove: false,
    accessibility: true,
    autoplay: true,
    speed: 300,
    cssEase: 'ease-in-out'
  });

  $('.c-return-point-detail--status-items .c-button--close').click(function(){
    $('.c-return-point-detail--status-items').hide();
  });
  // the sameHeight functions makes all the selected elements of the same height
  $('.c-news-card-copy__summary p').sameHeight(); 
  $('.c-news-card-copy h4').sameHeight(); 

  /**
   * Overwrite contact us form behaviour 
   */ 
  // Contact us form on contact us page
  // if($('.c-form--contact-us').length){
  //   if (document.location.hash) {
  //     $('html, body').animate({ scrollTop: $(document.location.hash).offset().top - 200}, "slow");
  //   }
  // }
  if (document.location.hash) {
    $('html, body').animate({ scrollTop: $(document.location.hash).offset().top - 200}, "slow");
  }
  // Contact us form on detail page
  if($('.c-return-point-detail--feedback').length){
    if (document.location.hash) {
      $('html, body').animate({ scrollTop: $(document.location.hash).offset().top - 200}, "slow");
      $('.wpcf7').parent().parent().attr('aria-hidden', 'false');
      $('.wpcf7').parent().parent().prev('.js-accordion__header').attr('aria-expanded', 'true');
      $('.wpcf7').parent().parent().prev('.js-accordion__header').attr('aria-selected', 'true');
    }
  }

  $('.js-search-show-more').click(function() {
    $('.c-search-results-list__items').toggleClass('is-scrollable');
    $('.c-search-results__show-more').toggleClass('is-hidden');
  });


  var filters = [];
  $('.js-filter-location-checkbox').change(function (){
      var newList = [];
      
      // Update the array that tracks what filters are selected
      if ($(this).prop('checked') == true){
        filters.push($(this).val());
      } else {
        for( var i = 0; i < filters.length; i++){ 
          if ( filters[i] === $(this).val()) {
            filters.splice(i, 1);
          }
        }
      }


      if (filters.length > 0 ) {
        for (var i = 0; newList.length < 10 && i < locationDataWT.length; i++) {
            var returnPointType = locationDataWT[i].cp_collection_point_type;
            for (var j = 0; j < filters.length; j++) {
                if (returnPointType === filters[j]){
                    locationDataWT[i].mapIndex = i;
                    newList.push(locationDataWT[i]);
                }
            }
        }
        $('.c-search-results-list__items').empty();
        scrollableList(newList);
      } else {
         for (var i = 0; newList.length < 10; i++) {
           newList.push(locationDataWT[i]);         }
        $('.c-search-results-list__items').empty();
        locationDataWT[i].mapIndex = i;
        scrollableList(newList);
      }
    });

    $('.location-list__item').click(function(e) {
      var w = window.innerWidth;
      if (w > 768) {
        e.preventDefault();
        var dataClick = $(this).data("click");
        google.maps.event.trigger(window.globalMarker[dataClick], 'click');
      }
    });

    $('input[type=radio][name=mapToggle]').change(function() {
      if (this.value === 'list') {
        $('.maplist-wrapper').removeClass('show-map');
      } else {
        $('.maplist-wrapper').addClass('show-map');
      }
    });


    $('.js-expand-map').click(function(e){
      e.preventDefault();
      $('.c-return-point-result--map-view').toggleClass('show');
      $('.rp-details-map').toggleClass('show');
      

    });
    // Insert Meta tag for return points
    // if($('.c-inner-banner__map-wrapper').length) {
    //   const metaAddress = $('.c-return-point-card-address p').text();
    //   const metaType = $('.banner-details-type p').text();
    //   const insertMeta = '<meta name="description" content="Find your local return point at '+metaAddress+'. Take your containers to this '+metaType+' and receive a 10c refund or donate the proceeds to charity.">';
    //     $('head title').after(insertMeta);
    // }
});

function scrollableList(returnPointsList){
    for (var i = 0; i < returnPointsList.length && i < 10; i++) {
        var rpTitle = returnPointsList[i].cp_title;
        var rpStatus = returnPointsList[i].cp_status;
        var rpType = returnPointsList[i].cp_collection_point_type;
        var rpSuburb = returnPointsList[i].cp_city;
        var rpOpenCloseStatus = returnPointsList[i].cp_open_close_state_messages.map;
        var rpAddress = returnPointsList[i].cp_address;
        var rpTypeIconUrl = returnPointsList[i].cp_type_icon;
        var rpUrl = returnPointsList[i].cp_url;
        var rpDistance = returnPointsList[i].cp_distance;
        var rpStatusClass = returnPointsList[i].cp_status_class;
        var dataClick = returnPointsList[i].mapIndex;

        $('.c-search-results-list__items').append(
            "<a class='location-list__item' href='" + rpUrl + "' data-bitwise='"+ returnPointsList[i].cp_bitwise_sum +"' data-click='" + dataClick + "'>\n\
                <img src='"+ rpTypeIconUrl + "' alt='" + rpType +"' class='location-list__image'>\n\
                <div class='location-list__description'>\n\
                    <h5 class='location-list__description-title'>" + rpTitle + "</h5>\n\
                    <p>" + rpType + "</p>\n\
                    <p>" + rpAddress + " - " + rpDistance + " km</p>\n\
                    <p class='" + rpStatusClass + "'>" + rpOpenCloseStatus +"</p>\n\
                </div>\n\
            </a>\n\
        ");
    }
    $('.location-list__item').click(function(e) {
      var w = window.innerWidth;
      if (w > 768) {
        e.preventDefault();
        console.log('clicked');
        var dataClick = $(this).data("click");
        console.log(dataClick);
        google.maps.event.trigger(window.globalMarker[dataClick], 'click');
      }
    });
}

function getFilteredList(filters) {
    var newList = [];
    
    for (var i = 0; newList.length < 10; i++) {
        var returnPointType = locationDataWT[i].cp_collection_point_type;
        for (var j = 0; j < filters.length; j++) {
            if (returnPointType == filters[j]){
                newList.push(locationDataWT[i]);
            }
        }
    }
    $('.c-search-results-list__items').empty();
    scrollableList(newList);
}


// WEBPACK FOOTER //
// ./FE-Build/src/js/scripts.js